export enum ChooseTypeEnum {
  poi,
  trip
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/enums/chooseType.enum.ts